export default {"src":"/_next/static/media/Risks.ed810e9c.svg","height":366,"width":364,"blurWidth":0,"blurHeight":0};